var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 37.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.57,21a8,8,0,0,1-11.2,0l-3.23-3A3.67,3.67,0,0,1,1,12.72l.13-.13a4.15,4.15,0,0,1,5.7,0c2.09,2.09,4.56,1.9,6.08.38a3.69,3.69,0,0,0,.16-5.22,4,4,0,0,0-.54-.48,3.67,3.67,0,0,1-.13-5.19L12.54,2a4.13,4.13,0,0,1,5.7,0l3.23,3a7.35,7.35,0,0,1,.25,10.39c-.08.09-.17.17-.25.25L38.75,32.15c3.8,3.61-1.9,8.94-5.7,5.32Z",
    transform: "translate(0 -0.82)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMenuIcon);
export default __webpack_public_path__ + "static/media/settings_menu_icon.8879a06d.svg";
export { ForwardRef as ReactComponent };